import { render, staticRenderFns } from "./mermaid-block.vue?vue&type=template&id=5be5c524&scoped=true"
import script from "./mermaid-block.vue?vue&type=script&lang=ts"
export * from "./mermaid-block.vue?vue&type=script&lang=ts"
import style0 from "./mermaid-block.vue?vue&type=style&index=0&id=5be5c524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5c524",
  null
  
)

export default component.exports